<template>
  <div>
    <!-- <div class="notes">注: 以下页数按单面计算，双面自动2倍，</div> -->
    <Alert type="warning" style="width: 712px;padding-right: 16px;font-size:12px">
      提示：以下页数按单面计算，双面将自动2倍；此方案适用于将A3和双色独立出来收费的模式，填写指引参照"常规收费"
    </Alert>
    <Form ref="formInline" :model="itemData" :rules="rule" :label-width="160" inline>
      <FormItem prop="name" label="方案名称:">
        <Input v-model="data.name" placeholder="抄表结算方案名称"/>
      </FormItem>
      <FormItem prop="basics" label="基础金额(元):">
        <InputNumber style="width:141px" :active-change="false" :precision="2" :min="0" :step="1" v-model="data.basics"/>
      </FormItem>
      <FormItem label="结算方案描述">
        <Input style="width: 141px" v-model="data.describe"/>
      </FormItem>
      <br/>
      <FormItem label="免费A4黑白(页):">
        <InputNumber :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.blackA4Num"/>
      </FormItem>
      <FormItem label="免费A4彩色(页):">
        <InputNumber :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.colorA4Num"/>
      </FormItem>
      <FormItem label="免费A3黑白(页):">
        <InputNumber :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.blackA3Num"/>
      </FormItem>
      <FormItem label="免费A3彩色(页):">
        <InputNumber :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.colorA3Num"/>
      </FormItem>
      <FormItem label="免费双色(页):">
        <InputNumber :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.bothNum"/>
      </FormItem>
      <br/>
      <FormItem label="超出A4黑白(元/页):">
        <InputNumber :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.blackA4Money"/>
      </FormItem>
      <FormItem label="超出A4彩色(元/页):">
        <InputNumber :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.colorA4Money"/>
      </FormItem>
      <FormItem label="超出A3黑白(元/页):">
        <InputNumber :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.blackA3Money"/>
      </FormItem>
      <FormItem label="超出A3彩色(元/页):">
        <InputNumber :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.colorA3Money"/>
      </FormItem>
      <FormItem label="超出双色(元/页):">
        <InputNumber :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.bothMoney"/>
      </FormItem>
      <br/>
      <FormItem>
        <Button type="success" @click="save"  v-preventReClick :loading="loading">保存</Button>
      </FormItem>
    </Form>
    <!-- <div class="formula-box">
      <div class="row">A4黑白印张 = 黑白总计数 - 2 * A3黑白印张</div>
      <div class="row">A4彩色印张 = 彩色总计数 - 双色 - 2 * A3彩色印张</div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'type3',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      rule: {
        name: [{ validator: (rule, value, cb) => {
          if (!this.data.name) {
            cb(new Error('方案名称未填'))
          } else {
            cb()
          }
        },
        required: true,
        trigger: 'blur' }],
        basics: [{ validator: (rule, value, cb) => {
          if (this.data.basics >= 0) {
            cb()
          } else {
            cb(new Error('基础金额未填'))
          }
        },
        required: true,
        trigger: 'blur' }]
      },
      itemData: {
        blackA4Num: null,
        blackA4Money: null,
        blackA3Num: null,
        blackA3Money: null,
        colorA4Num: null,
        colorA4Money: null,
        colorA3Num: null,
        colorA3Money: null,
        bothNum: null,
        bothMoney: null
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      if (this.data.id && this.data.type == 4) {
        this.itemData = JSON.parse(this.data.content)
      }
    },
    save () {
      this.$refs.formInline.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.data.agent_id = this.user.id
          this.data.content = JSON.stringify(this.itemData)
          this.data.type = '4'
          this.SaveMeterCharge(this.data).then(res => {
            if (res) {
              this.data.id = res
              this.$Message.success('保存成功')
            }
            this.loading = false
          })
        }
      })
    },
    ...mapActions(['SaveMeterCharge'])
  },
  computed: mapGetters({
    user: 'agent'
  })
}
</script>

<style lang="less" scoped>
  @import '../index.less';
</style>
